import Axios from "axios";

const URL = `${process.env.REACT_APP_BACKEND_URL}/admin/qa`;

function headers() {
  return { authorization: localStorage.getItem("nssc-admin-token") };
}

// The backend answers 200 with { status, data | message }; 401 means the admin token is gone.
async function unwrap(request) {
  const { data } = await request;
  if (data.status === 401) {
    localStorage.removeItem("nssc-admin-token");
    window.location.href = "/login";
    throw new Error(data.message || "Unauthorized");
  }
  if (data.status !== 200) {
    const err = new Error(data.message || "Request failed");
    err.fromServer = true;
    throw err;
  }
  return data.data;
}

export const fetchState = () => unwrap(Axios.get(URL, { headers: headers() }));
export const sendAction = (payload) => unwrap(Axios.post(URL, payload, { headers: headers() }));
